const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = '='.repeat((4 - (normalized.length % 4)) % 4);
  return globalThis.atob(`${normalized}${padding}`);
};

export const getTokenExpiration = (token) => {
  if (typeof token !== 'string') return null;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(decodeBase64Url(parts[1]));
    return typeof payload.exp === 'number' && Number.isFinite(payload.exp) ? payload.exp : null;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token, { now = Date.now(), clockSkewSeconds = 30 } = {}) => {
  const expiresAt = getTokenExpiration(token);
  if (!expiresAt) return true;
  return expiresAt <= Math.floor(now / 1000) + clockSkewSeconds;
};
